<template>
  <ul>
    <slot></slot>
  </ul>
</template>

<script>
export default {};
</script>
